/**
 * Serviço para operações relacionadas a defeitos
 * Migrado de App.js para estrutura modular
 */

// Desenvolvimento: localhost:3002. Produção: mesma origem (Apache proxy encaminha /api)
const getApiBaseUrl = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:3002';
  }
  return window.location.origin;
};

const API_BASE_URL = getApiBaseUrl();

/**
 * Busca defeitos por termo de pesquisa
 * @param {string} searchTerm - Termo de busca
 * @param {string|null} [codEquip] - TB01010_CODIGO (codprod); backend filtra por equipamento se a config estiver ativa
 * @returns {Promise<{success: boolean, items: Array}>}
 */
export const searchDefeitos = async (searchTerm, codEquip = null) => {
  if (!searchTerm || searchTerm.trim().length === 0) {
    return {
      success: true,
      items: []
    };
  }

  try {
    const token = localStorage.getItem('authToken');
    const q = new URLSearchParams({ search: searchTerm.trim() });
    if (codEquip != null && String(codEquip).trim() !== '') {
      q.set('codEquip', String(codEquip).trim());
    }
    const response = await fetch(`${API_BASE_URL}/api/defeitos?${q.toString()}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Erro ao buscar defeitos');
    }

    const data = await response.json();
    return {
      success: data.success || false,
      items: data.items || []
    };
  } catch (error) {
    console.error('Erro ao buscar defeitos:', error);
    return {
      success: false,
      items: [],
      error: error.message
    };
  }
};

